import React, { useState } from 'react';
import { faqItems, supportVideos, type SupportVideo } from './support.data';
import SupportVideoSection from './SupportVideoSection';
import VideoPlayerModal from './VideoPlayerModal';
import FAQSection from './FAQSection';
import ContactSupport from './ContactSupport';
import './support.css';

/**
 * In-app Support Center. Route: `?section=support` (existing pattern).
 * Data comes from `support.data.ts` today; swap to `supportApi.getVideos()`
 * later without touching the child components.
 */
const SupportPage: React.FC = () => {
  const [activeVideo, setActiveVideo] = useState<SupportVideo | null>(null);

  return (
    <div className="support-center">
      <header className="support-page-header">
        <h2>Support</h2>
        <p className="support-page-subtitle">Get help with creating and using Pixle.</p>
      </header>

      <SupportVideoSection videos={supportVideos} onSelectVideo={setActiveVideo} />

      <FAQSection items={faqItems} />

      <ContactSupport />

      <VideoPlayerModal
        video={activeVideo}
        isOpen={activeVideo !== null}
        onClose={() => setActiveVideo(null)}
      />
    </div>
  );
};

export default SupportPage;
